(() => {
  const root = document.documentElement;
  const announcementBar = document.querySelector('.utility-bar');
  const header = document.querySelector('.header-99');

  const setOffsets = () => {
    const announcementHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    root.style.setProperty('--announcement-height', `${announcementHeight}px`);
    root.style.setProperty('--header-99-height', `${headerHeight}px`);
  };

  setOffsets();
  window.addEventListener('resize', setOffsets);
  window.addEventListener('load', setOffsets);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(setOffsets);
  }
})();